export default "/_next/static/fonts/53ee0dd751c9e05cec8287c43923691a.woff";